var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-final-result-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_ImportFinalResult"),
            width: "530px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "span",
              { staticStyle: { "font-size": "14px", "padding-left": "15px" } },
              [
                _vm._v(_vm._s("【")),
                _c(
                  "a",
                  {
                    staticStyle: { color: "blue" },
                    on: { click: _vm.onViewClick }
                  },
                  [_vm._v(_vm._s(this.filingBatchNo))]
                ),
                _vm._v(
                  _vm._s(
                    "】" + this.$t("CargoMsg.Cargo_SureToImportFinalResult")
                  )
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-left": "0px", "padding-top": "35px" }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "importPrice",
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "5px",
                    "margin-right": "5px"
                  },
                  attrs: {
                    action: _vm.URL.price.openPrice.importFinalResultExcel,
                    headers: { sessionId: _vm.sessionId },
                    "show-file-list": false,
                    multiple: false,
                    "auto-upload": false,
                    accept: ".xls,.xlsx",
                    "before-upload": _vm.beforeUpload,
                    "on-success": _vm.uploadExcelSuccess,
                    "on-error": _vm.uploadExcelError,
                    data: { filingBatchNo: this.filingBatchNo || "" },
                    "on-progress": _vm.uploadProcess,
                    "on-change": _vm.handleChange
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", no: "selectFile" } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SelectFile")))]
                  )
                ],
                1
              ),
              _c("el-input", {
                staticClass: "fileNameClass",
                staticStyle: { "font-size": "13px", "padding-right": "5px" },
                attrs: { no: "txtFileName", readonly: true },
                model: {
                  value: _vm.txtFileName,
                  callback: function($$v) {
                    _vm.txtFileName = $$v
                  },
                  expression: "txtFileName"
                }
              }),
              _c("p", [
                _c(
                  "a",
                  {
                    staticStyle: { "font-size": "13px", color: "blue" },
                    on: { click: _vm.removeFile }
                  },
                  [_vm._v("X")]
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    no: "confirm",
                    disabled: _vm.txtFileName === ""
                  },
                  on: { click: _vm.importExcelHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }